import React, { useContext } from 'react';
import uuid from 'uuid-random';
import { TextPresentationPageContext, ActionTypes } from '../../../contexts/textPresentationPageContext';
import { DraggableNote } from '../../DraggableNote/DraggableNote';
import { INote, IPosition } from '../../../types';
import { getStageColors } from '../../../utils';

interface IScreen {
  editMode: boolean;
  stage: string;
}

export const TextPresentationScreen = (props: IScreen): JSX.Element => {
  const { editMode, stage } = props;

  const { state, dispatch, saveNoteContentUpdates, saveNotePositionUpdates, saveRemoveNoteUpdates } =
    useContext(TextPresentationPageContext);

  const handleNoteDragStop = (id: string, position: IPosition, content: string) => {
    let isPositionUpdated = false;

    const payload = state.notes.map(note => {
      if (note.id !== id) return note;

      isPositionUpdated = JSON.stringify(note.position) !== JSON.stringify(position);

      if (!isPositionUpdated) return note;

      return {
        ...note,
        isFocussed: false,
        position,
        selectionStart: content.length,
      };
    });

    if (isPositionUpdated) {
      saveNotePositionUpdates(state.notes, payload);

      dispatch({ type: ActionTypes.UPDATE_NOTE, payload });
    }
  };

  const handleRemoveElement = (id: string) => {
    const restNotes = state.notes.filter(note => {
      return note.id !== id;
    });

    const payload = [...restNotes] as Array<INote>;

    dispatch({ type: ActionTypes.UPDATE_NOTE, payload });

    saveRemoveNoteUpdates(state.notes, payload);
  };

  const handleNoteBlur = (id: string, content: string, selectionStart: number) => {
    const payload = state.notes.map(note => {
      if (note.id !== id) return note;

      const isContentUpdated = note.content !== content;

      if (!isContentUpdated)
        return {
          ...note,
          isFocussed: false,
        };

      return {
        ...note,
        content,
        selectionStart,
        isFocussed: false,
      };
    }) as Array<INote>;

    saveNoteContentUpdates(state.notes, payload);

    dispatch({ type: ActionTypes.UPDATE_NOTE, payload });
  };

  const { main, dark } = getStageColors(stage);

  const noteColors = {
    primary: main,
    dark,
  };

  return (
    <>
      {state.notes.map(note => {
        const { id, isFocussed, isManuallyHidden, selectionStart, position, content } = note;

        return (
          <DraggableNote
            id={id as string}
            key={uuid()}
            editMode={editMode}
            selectionStart={selectionStart}
            content={content}
            position={position}
            isFocussed={isFocussed}
            isManuallyHidden={isManuallyHidden}
            colors={noteColors}
            handleStop={handleNoteDragStop}
            handleRemove={handleRemoveElement}
            handleBlur={handleNoteBlur}
          />
        );
      })}
    </>
  );
};
